function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import Measure from "react-measure";
import PropTypes from "prop-types";

var Timer = function (_React$Component) {
  _inherits(Timer, _React$Component);

  function Timer(props) {
    _classCallCheck(this, Timer);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      fontSize: 0
    };

    _this.handleTick = function () {
      var newPosition = _this.state.position - 1;

      _this.setState({
        position: newPosition
      });

      if (newPosition === 0) {
        clearInterval(_this.timeInterval);

        _this.props.handler();
      }
    };

    _this.handleSizeChange = function (_ref) {
      var bounds = _ref.bounds;

      _this.setState({
        fontSize: bounds.height / 2
      });
    };

    _this.state = {
      fontSize: 0,
      position: props.timeout
    };
    return _this;
  }

  Timer.prototype.componentDidMount = function componentDidMount() {
    this.timeInterval = setInterval(this.handleTick, 1000);
  };

  Timer.prototype.componentWillUnmount = function componentWillUnmount() {
    clearInterval(this.timeInterval);
  };

  Timer.prototype.render = function render() {
    var _state = this.state,
        fontSize = _state.fontSize,
        position = _state.position;
    return React.createElement(Measure, {
      bounds: true,
      onResize: this.handleSizeChange
    }, function (_ref2) {
      var measureRef = _ref2.measureRef;
      return React.createElement("div", {
        ref: measureRef,
        className: "recorder-start-stop-timer",
        style: {
          fontSize: fontSize + "px",
          lineHeight: fontSize * 2 + "px"
        }
      }, position);
    });
  };

  return Timer;
}(React.Component);

Timer.propTypes = process.env.NODE_ENV !== "production" ? {
  timeout: PropTypes.number,
  handler: PropTypes.func.isRequired
} : {};
Timer.defaultProps = {
  timeout: 3
};
export default Timer;